<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.query_name"
                    label="Nombre de la consulta"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.query_name"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Ruta al payload: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.payload_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" style="display: inline-block; width: 100%">
                        <v-select
                          v-model="stage.entity_type_id"
                          :items="available_types"
                          label="Tipo de salida"
                          item-text="name"
                          item-value="uuid"
                          outlined
                          hide-details="auto"
                        />
                      </div>
                    </template>
                    <span style="max-width: 350px; white-space: normal; display: block;" v-if="stage.entity_type_id">
                        {{available_types.find(t => t.uuid === stage.entity_type_id).schema}}
                    </span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.save_as_key"
                    label="Clave de guardado"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.save_as_key"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        
    </div>
</template>

<script>
import { RunQuery } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';

export default {
    name:'RunQueryDetailComponent',
    components: {
        RouteInBagSelectorComponent
    },
    props:{
        stage: {
            type: RunQuery,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        my_bag: {
            type: Object,
            default: () => {}
        },
        available_types: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return {
        }
    },
    mounted(){
        console.log(this.stage);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        computeStage(){
            this.$emit('compute-stage');
            console.log("aaaaaaaaa")
        }
    },
    computed:{
        
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>